export default "__VITE_ASSET__86bb16b5__"